import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/general.action'
import updateGeneral from 'api/general/update'
import { IGeneralAPI } from 'store/states/general.state'

async function updateConfigEnterprise(data: Partial<IGeneralAPI>) {
  return updateGeneral(data)
}

function* UpdateConfigEnterpriseEffectSaga(action: fromActions.UpdateGeneral) {
  try {
    const { payload } = action
    const { data } = yield call(updateConfigEnterprise, payload)
    yield put(fromActions.Actions.updateSuccess(data))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    console.log('error: ', error)
  }
}

export function* updateSettingsGeneralWatcherSaga() {
  yield takeLatest(
    fromActions.GENERAL_CONFIG_UPDATE,
    UpdateConfigEnterpriseEffectSaga
  )
}
